module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1061.5cf72cf0.png";